import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { PAGES } from '../config';
import { userActions } from '../actions';
import { hasPreviouslyLoggedIn } from '../utils';
import { setRoute, path } from '../router';

export class App extends Component {
	static propTypes = {
		updateRoute: PropTypes.func,
		userActions: PropTypes.object,
		children: PropTypes.element.isRequired,
		hostAppProps: PropTypes.object,
		// HOCs
		router: PropTypes.object,
		publicPath: PropTypes.string,
	};
	static defaultProps = {
		hostAppProps: {},
	};
	componentWillMount() {
		this.setLoggedInStatus();
	}
	setLoggedInStatus(_hasPreviouslyLoggedIn = hasPreviouslyLoggedIn) {
		const { updateRoute, router, userActions, publicPath } = this.props;
		const prevLoggedInDetails = _hasPreviouslyLoggedIn();
		const {
			hostAppProps: {
				emailAddress: hostEmail,
				firstName: hostFirstName,
				lastName: hostLastName,
				fbLoginScope: hostFbLoginScope,
			},
		} = this.props;
		const emailAddress = hostEmail || prevLoggedInDetails.emailAddress;
		const firstName = hostFirstName || prevLoggedInDetails.firstName;
		const lastName = hostLastName || prevLoggedInDetails.lastName;

		emailAddress && userActions.updateEmailAddress(emailAddress);
		firstName && userActions.updateFirstName(firstName);
		lastName && userActions.updateLastName(lastName);
		hostFbLoginScope && userActions.updateFbLoginScope(hostFbLoginScope);
		userActions.setPropsFromHost(this.props.hostAppProps || {});

		if (prevLoggedInDetails.hasLoggedIn && emailAddress === prevLoggedInDetails.emailAddress) {
			setRoute(updateRoute, router)(path.join(publicPath, PAGES.PasswordPage.route));
		}
	}
	render() {
		const { children } = this.props;
		return (
			<div>{ children }</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	userActions: bindActionCreators(userActions, dispatch),
});

const AppComposed = withRouter(App);
export default connect(null, mapDispatchToProps)(AppComposed);



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/containers/App.js